import { useCallback } from 'react';

import { useDrawer } from '@cast/design-system';

import {
  OomKillWorkloadsDrawer,
  OomKillWorkloadsDrawerProps,
} from './OomKillWorkloadsDrawer';

export const useOomKillWorkloadsDrawer = () => {
  const { open } = useDrawer();

  const openOomKillWorkloadsDrawer = useCallback(
    (props: OomKillWorkloadsDrawerProps) => {
      open({ component: OomKillWorkloadsDrawer, props });
    },
    [open]
  );

  return {
    openOomKillWorkloadsDrawer,
  };
};
